export default "__VITE_ASSET__DAwg9aJl__"